import JQueryView, { on } from '../../../../common/views/jqueryView';
import { browserName } from '../../../../common/helpers/applicationHelper';
import $ from 'jquery';

export default class ShowView extends JQueryView {
  tocItems: { index: string; text: string; className: string }[] = [];
  registrationModalHeight: number;

  constructor(isMobile: boolean) {
    super('#show');
    this.registrationModalHeight = 0;

    if (!isMobile) {
      this.renderToc();
      this.handleToc();
      this.handleAnchor();

      //その他の開示中プロジェクト の表示位置を調整する
      if ($('.header-3')[0]) {
        $('.header-to-projects').css({
          position: browserName() === 'safari' ? '-webkit-sticky' : 'sticky',
          bottom: 120,
        });
      } else {
        $('.header-to-projects').css({
          position: browserName() === 'safari' ? '-webkit-sticky' : 'sticky',
          top: window.innerHeight - 80,
        });
      }

      $('.header-3').css({
        position: browserName() === 'safari' ? '-webkit-sticky' : 'sticky',
        bottom: 0,
      });
    } else {
      this.modalIosScrollable();
      this.disableContentButtons();
    }
    this.setRegistrationModalHeight();
    this.handleRegistrationModal();
    this.loadFacebookSdk();
  }

  @on({ event: 'click', selector: '.modal-social__btn.share' })
  onClickPopup(event: JQuery.ClickEvent) {
    event.preventDefault();
    const intWidth = '500';
    const intHeight = '400';
    const strTitle =
      typeof event.currentTarget.title !== 'undefined'
        ? event.currentTarget.title
        : 'Social Share';
    const strParam = `width= ${intWidth} ,height= ${intHeight}`;
    window.open(event.currentTarget.href, strTitle, strParam)?.focus();
  }

  @on({ event: 'click', selector: '.risk_info_link' })
  onClickRiskInfo() {
    $('.nav-tabs a[href="#risk_info"]').tab('show');
  }

  handleAnchor() {
    const url = document.location.toString();
    if (/#/.test(url)) {
      $('.tab-nav a[href="#' + url.split('#')[1] + '"]').tab('show');
    }
  }

  handleToc() {
    $('body').scrollspy({ target: '.toc' });

    $('a[data-toggle="tab"]').on(
      'shown.bs.tab',
      (event: JQuery.TriggeredEvent) => {
        if (
          this.tocItems.length > 0 &&
          $(event.target).html() === 'プロジェクト詳細'
        ) {
          $('.toc').show();
        } else {
          $('.toc').hide();
        }
      },
    );
  }

  renderToc() {
    const selector = '.mokuji';

    $('#description')
      .find(selector)
      .each((i: number, item: HTMLElement) => {
        const trimmed = item.dataset.tocTitle
          ? item.dataset.tocTitle.trim()
          : item.textContent?.trim();
        if (trimmed == null) {
          return;
        }

        const text = trimmed.replace('■ ', '').replace('■', '');
        if (text !== '') {
          const index = item.id || `toc-${i}`;
          const sanitizedClassName = selector
            .replace(/((:+[\w-\d]*)|[^A-z0-9-\s])/g, ' ')
            .replace(/\s{2,}/g, ' ')
            .trim();
          const className = `toc-${sanitizedClassName}`;

          if (item.id !== index) {
            item.id = index;
          }

          this.tocItems.push({ index, text, className });
        }
      });

    if (this.tocItems.length > 0) {
      let html = '<div class="list-group" data-turbo="false">';
      html += '<div class="list-group-item list-group-item-heading">目次</div>';

      const triggerOptions = [];

      this.tocItems.forEach((item, j) => {
        const options = {
          el: `.toc-li-${j}`,
          fixed: 'true',
          start: `#${item.index}`,
          position: 'top',
          positionEnd: 'top',
          className: 'toc-visible',
        };
        html += `\n<a href="#${item.index}" class="list-group-item list-group-item-action toc-li-${j} ${item.className}">${item.text}</a>`;
        triggerOptions.push(options);
      });

      html += '</ul>';

      $('.toc').html(html);
    } else {
      $('.toc').hide();
    }
  }

  loadFacebookSdk() {
    (function (d: Document, s: string, id: string) {
      if (d.getElementById(id)) {
        return;
      }
      const fjs = d.getElementsByTagName(s)[0] as HTMLElement;

      const js = d.createElement(s);
      js.id = id;
      js.setAttribute(
        'src',
        'https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v3.1',
      );
      fjs.parentNode?.insertBefore(js, fjs);
    })(document, 'footer', 'facebook-jssdk');
  }

  modalIosScrollable() {
    let previousScrollY = 0;

    $(document)
      .on('show.bs.modal', () => {
        previousScrollY = window.scrollY;
        $('html').addClass('modal-open').css({
          marginTop: -previousScrollY,
          overflow: 'hidden',
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          position: 'fixed',
        });
      })
      .on('hidden.bs.modal', () => {
        $('html').removeClass('modal-open').css({
          marginTop: 0,
          overflow: 'visible',
          left: 'auto',
          right: 'auto',
          top: 'auto',
          bottom: 'auto',
          position: 'static',
        });
        window.scrollTo(0, previousScrollY);
      });
  }

  setRegistrationModalHeight() {
    const modal = document.getElementById('blurred_modal');
    const element = document.getElementById('only_registered');
    if (!modal || !element) {
      return;
    }

    const position = element.getBoundingClientRect().top + window.scrollY;
    this.registrationModalHeight = position + 300;
    modal.style.top = `${position + 300}px`;
  }

  handleRegistrationModal() {
    const modal = document.getElementById('blurred_modal');
    const footer = document.getElementById('l-footer');
    const header = document.getElementById('g-header');
    if (!modal || !footer || !header) {
      return;
    }
    $(window).scroll(() => {
      const currentScroll =
        window.scrollY ||
        (document.documentElement ? document.documentElement.scrollTop : 0);
      const viewportHeight = window.innerHeight;
      const triggerPoint =
        this.registrationModalHeight -
        (viewportHeight / 2 - modal.offsetHeight / 2) +
        header.offsetHeight;

      if (
        currentScroll >= triggerPoint &&
        currentScroll < footer.offsetTop - viewportHeight
      ) {
        modal.classList.add('fixed');
        modal.style.top = `${viewportHeight / 2 - modal.offsetHeight / 2}px`;
      } else if (currentScroll >= footer.offsetTop - viewportHeight) {
        modal.classList.remove('fixed');
        modal.style.top = `${
          footer.offsetTop -
          modal.offsetHeight / 2 -
          viewportHeight / 2 -
          header.offsetHeight
        }px`;
      } else {
        modal.classList.remove('fixed');
        modal.style.top = `${this.registrationModalHeight}px`;
      }
    });
  }

  disableContentButtons() {
    const element = document.getElementById('only_registered');
    if (element && element.classList.contains('blurred')) {
      element.querySelectorAll('button').forEach(button => {
        if (button instanceof HTMLButtonElement) {
          button.disabled = true;
        }
      });
    }
  }
}
